// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"489": "MachineTranslationButtonContainer","664": "RelatedLinks","83": "CreateCollectionModal","882": "NotableClientsAbout","883": "SaveToListPopover",}[chunkId] + "." + {"489": "7d4ce7ad88f04eac","664": "20078fed043d6e13","83": "dbe080bb8d46f436","882": "1be94c8723fe58db","883": "3b6ca6466b1bfcd4",}[chunkId] + ".css"
}